/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { collaborationSettings, getTaxConsultingCategories } from '../../apis/tax-portal/tax-consulting';
import { dps, isEmpty } from '../../utils/lodashExtend';
import Form from '../Form';
import { chunk } from 'lodash';
import { shallowEqual, useSelector } from 'react-redux';
import { toast } from '../../utils/toast';
import systemAlert from '../../utils/systemAlert';
import NoData from '../NoData/NoData';

const defaultForm = {};

const CollaborationSetting = (props) => {
  const [categories, setCategories] = useState([]);
  const [fields, setFields] = useState([]);
  const { employee } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
    }),
    shallowEqual
  );


  const getData = () => {
    getTaxConsultingCategories({ isCollaboration: true })
      .then(res => {
        const _form = {};
        (res.data || []).forEach(item => {
          item.childCategories.forEach(category => {
            _form[`${category.idx}`] = category?.collaborationSetting?.used === true ? "true" : "false";
          });
        });
        setCategories(res.data);

        setForm(_form);
      });
  };

  const submit = (form) => {
    const collaborations = [];
    for (let [key, value] of Object.entries(form)) {
      if (key === "all") continue;
      const collaboration = {
        categoryIdx: +key,
        used: value === "true",
        employeeIdx: employee.employeeIdx
      };
      collaborations.push(collaboration);
    }

    systemAlert("협업 가능 여부를 변경하시겠습니까?", {
      buttons: [
        {
          label: "취소",
          color: "text"
        }, {
          label: "변경",
          onClick: () => {
            collaborationSettings({ collaborations })
              .then(res => {
                toast.success("설정이 완료되었습니다.");
                getData();
              });
          }
        }
      ]
    });

  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
  } = useForm(defaultForm, submit);



  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!isEmpty(categories) && employee) {

      const _fields = [{
        type: "radio",
        title: "전체",
        key: `all`,
        options: {
          list: [{ label: "가능", value: "true" }, { label: "불가", value: "false" }]
        },
        titlestyle: {
          fontSize: "22px"
        },
        onChange: (e) => {
          const { name, value } = e.target;

          const _form = { [name]: value };
          categories.forEach(item => {
            item.childCategories.forEach(category => {
              _form[`${category.idx}`] = value;
            });
          });

          setForm(_form);
        }
      }];
      categories.forEach(item => {
        _fields.push({
          type: "line"
        });
        _fields.push({
          // type: "radio",
          type: "title",
          title: item.name,
          key: `${item.idx}`,
          // options: {
          //   list: [{ label: "가능", value: "true" }, { label: "불가", value: "false" }]
          // },
          // titlestyle: {
          //   fontSize: "18px"
          // },
          onChange: (e) => {
            const { name, value } = e.target;
            const target = dps(categories, Number(name), 'childCategories');
            let _form = { [name]: value };
            if (!isEmpty(target.childCategories)) {
              target.childCategories.forEach(item => {
                _form[item.idx] = value;
              });
            }

            setForm(_form);
          }
        });
        _fields.push(...chunk(item.childCategories, 3)
          .map(list => {
            return [...list.map((category, idx) => {
              return {
                type: "radio",
                titlestyle: {
                  paddingTop: "12px",
                  paddingRight: "10px",
                  wordBreak: "keep-all"
                },
                title: category.name,
                key: `${category.idx}`,
                options: {
                  list: [{ label: "가능", value: "true" }, { label: "불가", value: "false" }]
                },
              };
            }), ...(list.length === 2 ? [{
              isHdie: ({ form }) => form?.idx === "99999999"
            }] : [])];
          }));
      });

      setFields(_fields);
    }
  }, [categories, employee, form]);

  return (
    <>
      {!isEmpty(form) ?
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"설정"}
          submit={handleSubmit}
        />
        : <NoData text="협업 여부 설정 가능한 컨설팅이 존재하지 않습니다." />
      }
    </>
  );
};

export default CollaborationSetting;